module.exports = __webpack_public_path__ + "ARIMO-REGULAR.96a51ca4bc3d40894491.ttf";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/PROD-mufit-web/src/assets/fonts/ARIMO-REGULAR.ttf
// module id = ../../../../../src/assets/fonts/ARIMO-REGULAR.ttf
// module chunks = styles